import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import { updateApartment } from '../../services/apartmentService';
import SuccessMessageModal from '../Reusable/SuccessMessageModal';
import WarningMessageModal from '../Reusable/WarningMessageModal';

const EditApartmentModal = ({ isOpen, onClose, apartment, onApartmentUpdated }) => {
  const [formData, setFormData] = useState({ matricula: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    if (apartment) {
      setFormData({ matricula: apartment.matricula || '' });
    }
  }, [apartment]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await updateApartment(apartment.apartment_id, formData);
      setModalMessage('Apartamento actualizado correctamente.');
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al actualizar el apartamento.';
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onApartmentUpdated();
    onClose();
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Editar Apartamento</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="matricula"
          label="Matrícula"
          type="text"
          fullWidth
          variant="standard"
          value={formData.matricula}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? <CircularProgress size={24} /> : 'Actualizar'}
        </Button>
      </DialogActions>
    </Dialog>
    <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
    <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </>
  );
};

export default EditApartmentModal;
